import {
  PositionedModelController,
  ContainerController,
  VisualController,
  VisualElement,
  SectionController,
  PositionedModelOwnerController,
} from '@sas-dvr/ltjs-bird';

export function getModel(controller: PositionedModelController | null) {
  if (!controller) {
    return null;
  }
  if (controller instanceof ContainerController) {
    const vec = controller.getVisualContainerElementController();
    if (!vec) {
      return null;
    }
    const model = vec.getModel();
    if (!model) {
      return null;
    }
    return model;
  } else if (controller instanceof VisualController) {
    // There is no good way to generically get the model since 'getModel' is implemented on all of the sub classes.
    const vec = controller.getVisualElementController();
    const vecAny = vec as any;
    if (typeof vecAny.getModel === 'function') {
      return vecAny.getModel() as VisualElement;
    }
  }
  return null;
}

export function getMediaContainerController(section: SectionController | null) {
  if (!section) {
    return null;
  }
  const body = section.getBodyController();
  if (!body) {
    return null;
  }
  return body.getMediaContainerController();
}

export function getControllerByName(
  container: PositionedModelOwnerController | null,
  name: string | null | undefined
): PositionedModelController | null {
  if (!container) {
    return null;
  }
  const items = container.getOrderedVisualAndContainerControllers();
  if (!items) {
    return null;
  }
  for (const item of items) {
    const model = getModel(item);
    if (model && model.getName() === name) {
      return item;
    }
    if (item instanceof ContainerController) {
      const vis = getControllerByName(item, name);
      if (vis) {
        return vis;
      }
    }
  }
  return null;
}
